export const presets = {
  template: {
    shape: {
      square: {
        width: 200,
        height: 200,
      },
      horizontal: {
        width: 299,
        height: 200,
      },
      vertical: {
        width: 220,
        height: 301,
      },
    },
    minWidth: 144,
    minHeight: 144,
    maxWidth: 344,
    maxHeight: 344,
    mobileWidth: 144,
    mobileHeight: 144,
    mobileMinWidth: 80,
    mobileMinHeight: 80,
    skeleton: {
      desktop: {
        width: 213,
        height: 200,
      },
      mobile: {
        width: 140,
        height: 140,
      },
    },
    skeletonMockImage: {
      width: 48,
      height: 39,
    },
    skeletonInput: {
      width: 181,
    },
  },
  project: {
    shape: {
      square: {
        width: 200,
        height: 200,
      },
      horizontal: {
        width: 200,
        height: 200,
      },
      vertical: {
        width: 200,
        height: 200,
      },
    },
    minWidth: 144,
    minHeight: 144,
    maxWidth: 344,
    maxHeight: 344,
    mobileWidth: 144,
    mobileHeight: 144,
    mobileMinWidth: 80,
    mobileMinHeight: 80,
    skeleton: {
      desktop: {
        width: 213,
        height: 200,
      },
      mobile: {
        width: 140,
        height: 140,
      },
    },
    skeletonMockImage: {
      width: 48,
      height: 39,
    },
    skeletonInput: {
      width: 181,
    },
  },
  asset: {
    shape: {
      square: {
        width: 200,
        height: 200,
      },
      horizontal: {
        width: 200,
        height: 200,
      },
      vertical: {
        width: 200,
        height: 200,
      },
    },
    minWidth: 144,
    minHeight: 144,
    maxWidth: 299,
    maxHeight: 338,
    mobileWidth: 144,
    mobileHeight: 144,
    skeleton: {
      desktop: {
        width: 213,
        height: 200,
      },
      mobile: {
        width: 140,
        height: 140,
      },
    },
    skeletonMockImage: {
      width: 48,
      height: 39,
    },
    skeletonInput: {
      width: 181,
    },
  },
};

export type TemplateProjectPresets = keyof typeof presets;
